import React from 'react';
import { MailOutlined } from '@ant-design/icons';
import OfferBanner from '../common/OfferBanner';

interface ReplyCaptureBannerProps {
  onSetUp: () => void;
  onDismiss: () => void;
}

const ReplyCaptureBanner: React.FC<ReplyCaptureBannerProps> = ({ onSetUp, onDismiss }) => (
  <OfferBanner
    icon={<MailOutlined />}
    ctaLabel="Set up reply tracking"
    onCta={onSetUp}
    onDismiss={onDismiss}
  >
    Replies arrive in your Gmail. Want them tracked here?
  </OfferBanner>
);

export default ReplyCaptureBanner;
